import Theme from '../../../theme';

const KioskActionsModalContainerStyle = `
  background: ${Theme.colors.darkAlternate.hexCode};
  grid-row-gap: 15px;
`;

export default KioskActionsModalContainerStyle;
